import styles from "./PrintQuarterSize_Reusable.module.css";

import gallery_icon from "../../../assets/images/icons/gallery_ace.svg";

import { Helmet } from "react-helmet";

import { useState } from "react";

import edit_1 from "../../../assets/images/edit_screen/PrintQuarterSize/edit_1.png";
import edit_2 from "../../../assets/images/edit_screen/PrintQuarterSize/edit_2.png";
import edit_3 from "../../../assets/images/edit_screen/PrintQuarterSize/edit_3.png";
import edit_4 from "../../../assets/images/edit_screen/PrintQuarterSize/edit_4.png";
const PrintQuarterSizeReusable = ({
  count,
  state,
  callback,
  image_selection_popup,
}) => {
  <Helmet>
    <script>
      {`
   (function(d) {
    var config = {
      kitId: 'tnx5lwp',
      scriptTimeout: 3000,
      async: true
    },
    h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
  })(document);
  `}
    </script>
  </Helmet>;

  const imgArray = state;

  const allImagesPicked = () => {
    let current = imgArray.reduce((total, item) => total + item.count, 0);
    console.log(current);
    console.log(count);
    if (current < count) {
      return false;
    }
    return true;
  };
  const imgPickedCount = () => {
    return imgArray.reduce((total, item) => total + item.count, 0);
  };

  const changeImageCount = (index, num) => {
    if (num === 0) {
      const temp = JSON.parse(JSON.stringify(state));
      temp.splice(index, 1);
      callback(temp);
    } else {
      const temp = JSON.parse(JSON.stringify(state));
      temp[index].count += num;
      callback(temp);
    }
  };

  const uploadImage = () => {
    console.log("comes here");
    if (allImagesPicked()) return;

    console.log("comes here2");
    image_selection_popup(1);
  };
  return (
    <div className={styles.main_div}>
      <div className={styles.top_hr}></div>
      <div name="編　集" className={styles.header_section}>
        写真選択
      </div>
      <div className={styles.edit_title_text_01}>写真選択してください。</div>
      <div onClick={uploadImage} className={styles.upload_image_placeholder}>
        <img
          className={styles.upload_image_gallery_icon}
          src={gallery_icon}
          alt="top_gallery"
        />

        <div className={styles.upload_image_placeholder_text}>写真選択</div>
      </div>
      <div className={styles.spacing01}></div>
      {Array.isArray(imgArray) &&
        imgArray.length > 0 &&
        imgArray.map((item, index) => {
          return (
            <div className={styles.image_single_container} key={index}>
              <div className={styles.image_main_div}>
                <img
                  src={item.src}
                  className={styles.edit_image}
                  alt="edit img"
                />
                <div
                  onClick={() => {
                    console.log("Cross the image");
                    changeImageCount(index, 0);
                  }}
                  className={styles.cross_div}
                >
                  <ion-icon
                    className={styles.cross_icon}
                    name="close"
                  ></ion-icon>
                </div>
              </div>
              <div className={styles.single_count_section_main}>
                <div
                  onClick={() => {
                    if (imgArray[index]["count"] <= 1) return;
                    changeImageCount(index, -1);
                  }}
                  className={styles.minus_div}
                >
                  _
                </div>
                <div className={styles.number_div}>{item.count}</div>
                <div
                  onClick={() => {
                    if (allImagesPicked()) return;
                    changeImageCount(index, 1);
                  }}
                  className={styles.plus_div}
                >
                  +
                </div>
                <div className={styles.number_text}>枚</div>
              </div>
              <div className={styles.image_single_bottom_hr}></div>
            </div>
          );
        })}
      <div className={styles.images_picked_main_div}>
        現在、合計枚数は
        <div className={styles.image_picked_number}>{imgPickedCount()}</div>
        枚です。
      </div>
    </div>
  );
};

export default PrintQuarterSizeReusable;
